export default "__VITE_ASSET__ZS6mUXVg__"